import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { HubConnectionBuilder } from '@microsoft/signalr';
import config from 'src/config/config';

import {
  setPaymentSuccess,
  setPaymentFailed,
  setWidgetLanguages,
  setWidgetSettings,
  setPaymentDataAfterPaid,
  setPaymentTransactionData,
  setPaymentTransactionsData,
} from 'src/store/slice/payment/slice';

import { useCustomSearchParams } from 'src/hook';

const useSignalR = () => {
  const dispatch: any = useDispatch();
  const { isDemo, paymentId } = useCustomSearchParams();

  const [connection, setConnection] = useState<any | null>(null);

  useEffect(() => {
    if (!isDemo) {
      const newConnection = new HubConnectionBuilder()
        .withUrl(`${config.apiUrl}/CryptoPayHub`)
        .withAutomaticReconnect()
        .build();

      setConnection(newConnection);
    }
  }, []);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then((result: any) => {
          connection
            .invoke('GetClientPayment', paymentId)
            .then((response: any) => {
              dispatch(setPaymentSuccess(response));
              dispatch(setWidgetLanguages(response));
              dispatch(setWidgetSettings(response));
              dispatch(setPaymentTransactionsData(response));
            })
            .catch((error: any) => {
              dispatch(setPaymentFailed());
            });

          connection.on('SendCompletedPaymentData', (response: any) => {
            dispatch(setPaymentDataAfterPaid(response));
          });

          connection.on('SendPaymentTransactionData', (response: any) => {
            dispatch(setPaymentTransactionData(response));
          });
        })
        .catch((event: any) => console.error(event));
    }
  }, [connection]);

  return null;
};

export { useSignalR };
